export default "__VITE_ASSET__2fcbc7ca__"